// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"289":"f7f97566","477":"0ea5b32e","483":"97cb5eab","487":"99d281b0"}[chunkId] + ".chunk.css";
};